var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"List-block-container common-container"},[_c('div',{staticClass:"List-block common-subcontainer"},[_c('div',{class:{
        'img-area': true,
        'sm': _vm.imgSize === 'sm',
        'md': _vm.imgSize === 'md',
        'md-lg': _vm.imgSize === 'md-lg',
        'lg': _vm.imgSize === 'lg',
      }},[_c('b-img-lazy',{attrs:{"src":_vm.img}})],1),_vm._v(" "),_c('div',{staticClass:"text-area title"},[_c('h3',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),_vm._v(" "),_c('div',{class:{
        'img-area': true,
        'empty': true,
        'sm': _vm.imgSize === 'sm',
        'md': _vm.imgSize === 'md',
        'md-lg': _vm.imgSize === 'md-lg',
        'lg': _vm.imgSize === 'lg'
    }}),_vm._v(" "),_c('div',{staticClass:"text-area"},[_vm._t("default"),_vm._v(" "),(_vm.link !== '')?_c('AnimatedLink',{attrs:{"text":_vm.bottomText,"type":_vm.linkType,"link":_vm.link}}):_vm._e()],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }